export default __webpack_public_path__ + "static/media/facebook.4b499f0c.svg";